import { defineMessages } from 'react-intl';

export default defineMessages({
  hangTight: {
    id: 'hangTight',
    defaultMessage: 'Hang tight while your list is importing…',
  },
  newLeadListErrorNotification: {
    id: 'newLeadListErrorNotification',
    defaultMessage: "We can't seem to upload the list at this time.",
  },
  newLeadListSuccessNotification: {
    id: 'newLeadListSuccessNotification',
    defaultMessage: 'Success!',
  },
  genLeadListSignedURLErrorNotification: {
    id: 'genLeadListSignedURLErrorNotification',
    defaultMessage: 'Something went wrong when retrieving the URL to upload the file.',
  },
});
